import React from 'react';
import { trackEvent } from '../utils/analytics';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Linkedin } from 'lucide-react';
import { SpotifyIcon } from './SpotifyIcon';
import { scrollToTop } from '../utils/scrollToTop';

// Public Spotify profile/search URL. Leave empty to hide the footer Spotify icon.
const SPOTIFY_URL = 'https://open.spotify.com/search/BWGELA%20Blogcast/shows';

const Footer = () => {
  return (
    <footer className="relative z-10 bg-black text-white py-8 border-t border-gray-800 w-full">
      <div className="w-full bg-black px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
        {/* Social links */}
        <div className="flex items-center justify-center gap-4 mb-6" data-testid="footer-social-links">
          <a
            href="https://www.instagram.com/bwgela"
            target="_blank"
            rel="me noopener noreferrer"
            aria-label="BWGELA on Instagram"
            data-testid="footer-instagram-link"
            className="inline-flex items-center justify-center w-9 h-9 rounded-lg text-white shadow-sm transition-transform hover:scale-110"
            style={{ background: 'linear-gradient(45deg, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)' }}
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href="https://www.youtube.com/@bwgela"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="BWGELA on YouTube"
            data-testid="footer-youtube-link"
            className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#FF0000] text-white shadow-sm transition-transform hover:scale-110"
          >
            <Youtube className="w-4 h-4" />
          </a>
          <a
            href="https://www.linkedin.com/company/bwgela"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="BWGELA on LinkedIn"
            data-testid="footer-linkedin-link"
            className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#0A66C2] text-white shadow-sm transition-transform hover:scale-110"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          {SPOTIFY_URL && (
            <a
              href={SPOTIFY_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BWGELA on Spotify"
              data-testid="footer-spotify-link"
              className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#1DB954] text-black shadow-sm transition-transform hover:scale-110"
            >
              <SpotifyIcon className="w-4 h-4" />
            </a>
          )}
        </div>

        {/* Footer Links - two columns */}
        <div className="flex justify-center gap-16 sm:gap-24 mb-6">
          {/* Support */}
          <div className="flex flex-col items-center gap-1">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-1">Support</p>
            <Link to="/help" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Help Center
            </Link>
            <Link to="/install" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Get the App
            </Link>
            <Link to="/settings" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Settings
            </Link>
            <Link to="/support-us" onClick={() => { scrollToTop(); trackEvent('donate_click', { location: 'footer_support' }); }} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Support Us
            </Link>
            <Link to="/subscribe" onClick={scrollToTop} data-testid="footer-subscribe-link" className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Subscribe
            </Link>
          </div>

          {/* Legal */}
          <div className="flex flex-col items-center gap-1">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-1">Legal</p>
            <Link to="/terms" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/cookies" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Cookie Policy
            </Link>
            <Link to="/modern-slavery" onClick={scrollToTop} className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Modern Slavery Statement
            </Link>
            <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noopener noreferrer" data-testid="footer-cc-license" className="text-xs text-[#F5E6D3] hover:text-white transition-colors">
              Creative Commons Licence
            </a>
          </div>
        </div>

        {/* Copyright - Below Links */}
        <div className="text-center">
          <p className="text-gray-400 text-sm">
            Copyright ©2026 BWGELA
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Version 1.0.0
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;